/**
 * Helpers for links
 * @module lib/links
 */

/**
 * Checks if the given link is a hash link to the same page as the current one
 * @param {HTMLAnchorElement} a
 */
export function isHashLinkOnSamePage(a) {
  return (
    a.hash &&
    a.href.replace(a.hash, '') ===
      window.location.href.replace(location.hash, '')
  );
}

/**
 * Checks if the given link is an empty hash link
 * @param {HTMLAnchorElement} a
 */
export function isEmptyHashLink(a) {
  return a.href === window.location.href.split('#')[0] + '#';
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/links.js